/**
 * The last calendar the server sent, kept on the phone.
 *
 * Opening the calendar paints this straight away and then refreshes it, so the
 * 2–3 seconds it takes the server to fetch and read the member's calendars is
 * spent looking at yesterday's picture rather than at a spinner. It is never
 * trusted as current: the view always refreshes, and says when it last did.
 *
 * It holds a member's meeting titles, so it is keyed to the member who saved it
 * and wiped on sign-out (see config/supabase.js).
 */

const KEY = "oe.calendarCache.v1";

/** @returns {{ userId, savedAt, window, events, feedStatus, feeds } | null} */
export function loadCalendarCache(userId) {
  if (!userId) return null;
  try {
    const saved = JSON.parse(window.localStorage.getItem(KEY) || "null");
    if (!saved || saved.userId !== userId || !Array.isArray(saved.events)) return null;
    return saved;
  } catch {
    return null;
  }
}

export function saveCalendarCache(userId, data) {
  if (!userId) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ userId, savedAt: Date.now(), ...data }));
  } catch {
    // Storage full or private mode. The calendar works the same, just without
    // the instant first paint.
  }
}

export function clearCalendarCache() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
